<template>
  <div class="hero" :style="{ 'background-image': 'url(' + bgImagePath + ')' }">
    <div class="content-wrapper">
      <h1
        v-html="title"
        class="hero__title">
      </h1>

      <p class="hero__text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
const imagesPath = require.context("../assets/images", true);

export default {
  name: "hero",

  props: {
    title: { type: String, required: false },
    text: { type: String, required: false },
    bgImageName: { type: String, required: true }
  },

  computed: {
    bgImagePath() {
      return imagesPath('./' + this.bgImageName, true);
    }
  }
}
</script>



// WEBPACK FOOTER //
// Hero.vue?2a407272